import { grey } from "@mui/material/colors";

const styles = {
  metricsWrapper: {
    py: 1,
    px: 2,
  },
  header: {
    color: "primary.main",
    fontWeight: 600,
    fontSize: 12,
    textTransform: "uppercase",
  },
  tab: {
    fontSize: 12,
    color: grey[500],
    px: 1,
    py: 0,
    minHeight: "40px",
    height: "40px",
  },
  tabs: { minHeight: "40px", height: "40px" },
};

export default styles;
